import styled from "styled-components";

export const Wrapper = styled.section`
  .subscription-input {
    width: 180px;
    border: 1px solid var(--field-color);
    border-radius: 6px;
    box-shadow: var(--box-shadow2);
  }
  .subtitle {
    font-size: var(--font-size-base);
    color: var(--blue-color-dark);
  }
  .submit-button {
    height: 40px;
    font-size: var(--font-size-lg);
    @media screen and (max-width: 576px) {
      font-size: var(--font-size-base);
    }
  }
`;
